"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePreview = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var utils_1 = require("../../../utils");

var CloseIcon_1 = require("./CloseIcon");

var FileIcon_1 = require("./FileIcon");

var FilePicker_styles_1 = require("./FilePicker.styles");

var FilePreview = function FilePreview(_ref) {
  var name = _ref.name,
      src = _ref.src,
      size = _ref.size,
      onRemoveClick = _ref.onRemoveClick,
      isUploading = _ref.isUploading,
      _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 0 : _ref$progress;
  var progressString = (0, utils_1.formatFileSize)(progress);
  var sizeString = (0, utils_1.formatFileSize)(size);
  return react_1.default.createElement("div", {
    className: FilePicker_styles_1.FILE_PREVIEW_STYLES.itemWrapper
  }, src ? react_1.default.createElement("img", {
    className: FilePicker_styles_1.FILE_PREVIEW_STYLES.image,
    src: src
  }) : react_1.default.createElement("div", {
    className: FilePicker_styles_1.FILE_PREVIEW_STYLES.image
  }, react_1.default.createElement(FileIcon_1.IconDocument, null)), react_1.default.createElement("div", {
    className: FilePicker_styles_1.FILE_PREVIEW_STYLES.details
  }, react_1.default.createElement("span", null, name), react_1.default.createElement("span", null, isUploading ? "".concat(progressString, " / ").concat(sizeString) : sizeString)), !isUploading && react_1.default.createElement("div", {
    className: FilePicker_styles_1.FILE_PREVIEW_STYLES.removeWrapper,
    onClick: onRemoveClick
  }, react_1.default.createElement(CloseIcon_1.CloseIcon, null)));
};

exports.FilePreview = FilePreview;